import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-http-auth',
  template: `
    <p>
      http-auth works!
    </p>
  `,
  styles: [
  ]
})
export class HttpAuthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
